import Vue from "vue";
import VueRouter from "vue-router";

import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: Layout,
    children: [
      {
        // 首页
        path: "",
        name: "home",
        component: () => import("@/views/index.vue"),
        meta: { title: "亿斯阁" },
      },
      {
        // 关于我们
        path: "aboutus",
        name: "aboutus",
        component: () => import("@/views/aboutus.vue"),
        meta: { title: "亿斯阁" },
      },
      {
        // 业务服务
        path: "service",
        name: "service",
        component: () => import("@/views/service.vue"),
        meta: { title: "亿斯阁" },
      },
      {
        // 新闻资讯
        path: "news",
        name: "news",
        component: () => import("@/views/news.vue"),
        meta: { title: "亿斯阁" },
      },
      {
        // 新闻资讯详情
        path: "newsdetail",
        name: "newsDetail",
        component: () => import("@/views/newsDetail.vue"),
        meta: { title: "亿斯阁" },
      },
      {
        // 常见问题
        path: "question",
        name: "question",
        component: () => import("@/views/question.vue"),
        meta: { title: "亿斯阁" },
      },
      {
        // 联系我们
        path: "contact",
        name: "contact",
        component: () => import("@/views/contact.vue"),
        meta: { title: "亿斯阁" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from) => {
  document.title = to.meta.title;
  window.scrollTo(0, 0);
});

export default router;
